"use client";

export default function OsanoConsentLink() {
  const handleClick = (e) => {
    e.preventDefault();
    if (window.Osano && window.Osano.cm) {
      try {
        // BL-398: this has to open Storage Preferences, the modal with the
        // category toggles. showDoNotSell() opens "Your Privacy Choices"
        // instead, and since it exists it always won the old if-chain, so the
        // preferences drawer was never reached. Order matters more than the
        // guards here.
        if (typeof window.Osano.cm.showDrawer === "function") {
          window.Osano.cm.showDrawer("osano-cm-dom-info-dialog-open");
        } else if (typeof window.Osano.cm.showDialog === "function") {
          window.Osano.cm.showDialog();
        }
      } catch (err) {
        console.error("Failed to trigger Osano consent manager:", err);
      }
    } else {
      console.warn("Osano CMP is not yet initialized.");
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="underline text-left hover:text-white/80 cursor-pointer inline-flex items-center min-h-6"
    >
      Do Not Sell or Share My Personal Information
    </button>
  );
}
